const jdTabs = function($container) {
  const tab = {
    dom: function() {
      this.$container = $container;
      this.$list      = this.$container.find('.' + this.class.list.self);
      this.$tabs      = this.$list.children();
      this.$arrow     = this.$container.find('.' + this.class.arrow.self);
    },

    class: {
      list: {
        self:         'tab__items',
        arrowVisible: 'tab__items--arrow-visible',
        shadowRight:  'tab__items--shadow-right',
        shadowLeft:   'tab__items--shadow-left'
      },

      arrow: {
        self: 'tab__arrow'
      },

      tab: {
        active: 'tab__item--active'
      }
    },

    tabsWidth: function(stopAtIndex) {
      var tabsWidth = 0;

      this.$tabs.each(function(i){
        tabsWidth += $(this).outerWidth();

        if (!isNaN(stopAtIndex)) {
          if (stopAtIndex == i) {
            return false;
          }
        }
      });

      return tabsWidth - this.tabBuffer();
    },

    tabBuffer: function() {
      return parseInt(this.$tabs.first().css('padding-left').replace(/px/, ''));
    },

    bindEvents: function() {
      var self = this;

      /**
       * Watch tab clicks. Scroll tabs into view if they
       * are tapped while partially out of view.
       */
      this.$tabs.click(function(){
        var fadeBuffer = 45; // Offset scroll position so item is not hidden under white scroll fade
        var rightOffset = self.tabsWidth($(this).index());
        self.$list.stop().animate({scrollLeft: (rightOffset - fadeBuffer) - $(this).outerWidth()});

        /**
         * This logic can be used to manage scroll based on visibility of the particular
         * item within the container. Abanoned this in favor of always advancing the
         * scroll whenever clicking new tabs, but we could bring this back if
         * we need to.
         */
        // var scrollPosition = self.$list.scrollLeft() + self.$list.outerWidth();
        // var tabBuffer = self.tabBuffer() + (fadeBuffer / 2);
        // var leftOffset = $(this).offset().left;
        // if (rightOffset > scrollPosition || leftOffset < tabBuffer) {
        //   self.$list.animate({scrollLeft: (rightOffset - fadeBuffer) - $(this).outerWidth()});
        // }
      }).on('active', function(){
        self.$tabs.removeClass(self.class.tab.active);
        $(this).addClass(self.class.tab.active);
      });

      /**
       * Watch arrow click. Scroll list to end. (This does
       * not currently handle sliding to "next" slide.
       * Can add later if necessary.)
       */
      this.$arrow.click(function(e){
        e.preventDefault();

        self.$list.animate({scrollLeft: self.tabsWidth()});
      });


      /**
       * Watch list scroll. Add appropriate shadows at
       * either end of the list when necessary. Remove
       * arrow when scrolling.
       */
      this.$list.scroll(function(){
        var scrollLeft = $(this).scrollLeft();

        if (scrollLeft > self.tabBuffer()) {
          self.$list.addClass(self.class.list.shadowLeft);

          if (!self.$arrow.data('hidden')) {
            self.$list.removeClass(self.class.list.arrowVisible);
            self.$arrow.fadeOut(200).data('hidden', true);
          }
        } else {
          self.$list.removeClass(self.class.list.shadowLeft);
        }

        if (scrollLeft + self.$list.outerWidth() >= self.tabsWidth()) {
          self.$list.removeClass(self.class.list.shadowRight);
        } else {
          self.$list.addClass(self.class.list.shadowRight);
        }
      });

      /**
       * Watch load & resize. Add appropriate shadows at
       * either end of the list when necessary. Add
       * arrow when necessary.
       */
      $(window).on('load resize', function(){
        if (self.$list.outerWidth() < self.tabsWidth()) {
          self.$list.addClass(self.class.list.shadowRight);

          if (!self.$arrow.data('hidden')) {
            self.$list.addClass(self.class.list.arrowVisible);
            self.$arrow.css('display', 'block');
          }
        } else {
          self.$list.removeClass(self.class.list.arrowVisible);
          self.$list.removeClass(self.class.list.shadowRight);
          self.$arrow.hide();
        }
      });
    },

    onTab: function(callback) {
      this.$tabs.click(function(e){
        e.preventDefault();

        /**
         * Sometimes switching tabs pulls elements further down
         * the page into view that have not been scrolled
         * to or animated in yet. Because of this, these
         * areas appear blank. When we change tabs, we
         * will force all remaining animations to
         * occur at once.
         */
        if ($('html').data('wow')) {
          $('.wow').each(function(){
            $('html').data('wow').show(this);
          });
        }

        $(this).trigger('active');
        callback($(this), e);
      });
    },

    init: function() {
      this.dom();

      if (this.$container.length) {
        this.bindEvents();
        this.$container.data('tab', this);
      }

      return this;
    }
  }

  return tab.init();
}
